// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import cardValidator from 'card-validator';
import _ from 'underscore';

export const cardTypes = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  discover: 'Discover',
  amex: 'American Express',
  jcb: 'JCB',
  maestro: 'Maestro',
  hipercard: 'Hipercard',
  elo: 'Elo',
  diners: 'Diners Club',
};

export const cardMaxLength = {
  [cardTypes.visa]: 16,
  [cardTypes.mastercard]: 16,
  [cardTypes.discover]: 19,
  [cardTypes.amex]: 15,
  [cardTypes.jcb]: 16,
  [cardTypes.maestro]: 19,
  [cardTypes.hipercard]: 16,
  [cardTypes.elo]: 16,
  [cardTypes.diners]: 19,
};

// Derive this by taking the maximum value stored in `cardMaxLength`
export const cardAutoTabLength = _(cardMaxLength)
  .chain()
  .keys()
  .map((key) => cardMaxLength[key])
  .max()
  .value();

const DELIMITER_LENGTH = 3; // 3 spaces between the 4 groups of numbers
// @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
export const cardFormattedAutoTabLength = cardAutoTabLength + DELIMITER_LENGTH;

export const removeWhitespaceAndDashes = (ccString: string): string => ccString.replace(/[\s-]/g, '');

// Replaces a string to only contain numbers
export const formatAsNumber = (val: string): string => (val ? val.replace(/[^0-9]/g, '') : '');

/**
 * Uses Luhn alogrithm to validate card
 * See https://github.com/braintree/card-validator for more details
 */
export const isValid = (ccString: string): boolean => {
  const cardNumber = formatAsNumber(ccString);
  return cardValidator.number(cardNumber).isValid;
};

/**
 * Return the card type (e.g. 'Visa') of a credit card
 * See https://github.com/braintree/card-validator for more details
 */
export const getCardType = (ccString: string): string | null => {
  const cardNumber = formatAsNumber(ccString);
  const cardValidation = cardValidator.number(cardNumber);
  return cardValidation.card?.niceType;
};

// Replaces a string to be separated in 4 number chunks (e.g. 1234 5678)
export const formatAsCardNumber = (ccString: string): string => {
  const cardNumber = formatAsNumber(ccString);
  const cardNumberLength = cardNumber.length;
  const cardValidation = cardValidator.number(cardNumber);
  const hasFormattingGaps = cardValidation.card?.gaps?.length > 0;

  if (!hasFormattingGaps) {
    return cardNumber;
  }

  let lastGap = 0;

  // `gaps` is an array where the gap in card number should be
  // e.g. `gaps: [4, 8, 12]` means the gap is at position 4, 8, 12
  // so the chunks are 4111 1111 1111 1111
  const chunks = cardValidation.card.gaps
    .filter((gap: number) => cardNumberLength > gap)
    .map((gap: number) => {
      const chunk = cardNumber.substring(lastGap, gap);
      lastGap = gap;
      return chunk;
    });

  if (cardNumberLength > lastGap) {
    chunks.push(cardNumber.substring(lastGap, cardNumberLength));
  }

  return chunks.join(' ');
};

export default {
  isValid,
  getCardType,
  cardTypes,
  cardMaxLength,
  cardAutoTabLength,
  cardFormattedAutoTabLength,
  formatAsNumber,
  removeWhitespaceAndDashes,
  formatAsCardNumber,
};
